<!-- eslint-disable max-lines -->
<template>
    <div class="customer-person">
        <Paper class="customer-person-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @elementChange="searchChange"
                        @search-change="accountList.searchList"
                    />
                    <div>
                        <el-radio-group v-model="initStatus" @input="inputStatus" size="mini">
                            <el-radio-button label="1" >待处理</el-radio-button>
                            <el-radio-button label="2,4">处理中</el-radio-button>
                            <el-radio-button label="3">最新归档</el-radio-button>
                        </el-radio-group>
                    </div>
                </template>
                <template slot="header-button">
                    <lots-button  v-has="authorityCode.incomeSharing" type="primary"  size="mini" @click="handleIncomeSharing()" >发起变更</lots-button>
                    <lotsButton
                        v-has="authorityCode.addNew"
                        type="primary"
                        size="mini"
                        @click="addNew"
                        title="新增">
                        <span class="icon iconfont">&#xe66a;</span> 新增
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.save"
                        type="primary"
                        icon="el-icon-circle-check"
                        size="mini"
                        title="保存"
                        :loading="saveLoading"
                        @click="handleSave">保存
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.transfer"
                        type="primary"
                        icon="el-icon-refresh"
                        size="mini"
                        title="转移"
                        @click="handleTransfer">转移
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.delete"
                        icon="el-icon-delete"
                        type="primary"
                        size="mini"
                        title="删除"
                        :loading="deleteLoading"
                        @click="handleDelete">删除
                    </lotsButton>
                    <report-export
                        #default="{ submit }"
                        reportCode="REPORT_CRM_CUSTOMER_MANAGER">
                        <lotsButton
                            v-has="authorityCode.export"
                            icon="el-icon-download"
                            type="primary"
                            size="mini"
                            @click="handleExport(submit, 'split')">导出
                        </lotsButton>
                    </report-export>

                    <!-- <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                            icon="iconfont icon-list_install"
                            type="primary"
                            size="mini"
                            :title="'列配置'"
                            @click="showColumnConfigDialog"
                            plain />
                    </el-tooltip> -->
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">

                    <edit-table-box
                        ref="editTableBox"
                        v-loading="accountList.tableLoading"
                        :control="getAuthRole()"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="accountList.totalData"
                        :actions="config.actions || []"
                        :allowRowClick="!getAuthRole()"
                        :allowRowClickFunc="config.rowClickFunc"
                        :key="rendertable"
                        :editDisableRule="editDisableRuleFun"
                        @selection-change="accountList.handleSelectedRow"
                        @element-change="handleChangeRow"
                        @btn-event="handleActive">
                        <template v-slot:col-append="{item, row, rIndex}">
                            <div class="col-append-box" v-show="item.prop === 'customerMobile' || item.prop==='customerEmail'">
                                <div class="col-append-content">
                                    {{ row[item.prop] ? ((item.prop === 'customerMobile' ? row.showMobile : row.showEmail) ? row[item.prop] : '****') : ''}}</div>
                                <div class="col-append-btn">
                                    <i
                                        title="查看完整信息"
                                        v-show="row[item.prop] && (item.prop === 'customerMobile' ? !row.showMobile : !row.showEmail)"
                                        class="el-icon-view eye-btn"
                                        :class="{'bigData-btn-viewPhone': item.prop === 'customerMobile', 'bigData-btn-viewEmail': item.prop==='customerEmail'}"
                                        @click="handelView(row, (item.prop === 'customerMobile' ? 'showMobile' : 'showEmail'))"></i>
                                </div>
                            </div>
                            <div class="col-append-box" v-show="item.prop === 'accountNumber'">
                                <div class="col-append-content">
                                    {{ row[item.prop] ? (row.showAccount ? row[item.prop] : '****') : ''}}</div>
                                <div class="col-append-btn">
                                    <i
                                        title="查看完整信息"
                                        v-show="row[item.prop] && !row.showAccount"
                                        class="el-icon-view eye-btn bigData-btn-viewAccount"
                                        @click="handelView(row, 'showAccount')"></i>
                                </div>
                            </div>
                            <div v-if="item.prop === 'mipUrl'">
                                <span size="mini" type="text" class="mip-page-link no-wrap"
                                    @click="handleLink(row)">{{  row.flowCode }}</span>
                            </div>
                            <span v-else-if="item.prop==='maintainStatus'">
                                {{ formatData(row,item)}}
                            </span>
                            <span v-else-if="['industryType','customerGroupCode','calCustomerLevelCode','mipStatus', 'ruleStatus'].includes(item.prop)">
                                {{ codesToNames(row[item.prop],item.optionsKey)}}
                            </span>
                        </template>
                           <template #edit-col-append="{ item, row, rIndex }">
                                <span size="mini" v-if="item.prop==='mipUrl'" type="text" class="mip-page-link no-wrap" @click="handleLink(row)">{{  row.flowCode}}</span>
                                 <el-select  v-else-if="item.prop==='maintainStatus'" v-model="row[item.prop]" :placeholder="item.placeholder">
                                    <el-option
                                        v-for="it in maintainStatusOptioins"
                                        :key="it.key"
                                        :label="it.val"
                                        :value="it.key"
                                        :disabled="it.disabled">
                                    </el-option>
                                </el-select>
                                <span v-else-if="['industryType','customerGroupCode','calCustomerLevelCode','mipStatus', 'ruleStatus'].includes(item.prop)">
                                    {{ codesToNames(row[item.prop],item.optionsKey)}}
                                </span>
                            </template>
                    </edit-table-box>
                    <!-- <column-config
                        :pageID="config.name"
                        :initColumns="config.columns"
                        ref="otpColumnConfig"
                        @header-change="config.columns = $event"
                    /> -->
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="accountList.sizeChange"
                        :current-page.sync="accountList.pageNo"
                        @current-change="accountList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="accountList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>
             <el-dialog
            :visible="transferVisible"
            width="40%"
            title="转移"
            destroy-on-close
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="handleClose">
            <el-form
                ref="myFormRef"
                :model="formData"
                label-width="140px"
                :rules="rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="单据所有人：" prop="billOwnerName">
                            <lots-md-input
                                :config="config.lotInputParams"
                                @change="(data) => { getAdvanceValue(data); }"
                            ></lots-md-input>
                        </el-form-item>
                        <span class="bill-tips-color" v-if="accountList.selectedRows.some(it => ['2', '4'].includes(String(it.maintainStatus)))">
                            *  存在“变更中/维护中”的数据
                        </span>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <lots-button type="primary" size="mini" @click="handleConfig">确 认</lots-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsMdInput from '@/components/lots/lotsMdInput';
import editTableBox from '@/components/lots/editTableBox/Index';
import {
    getCustomerManagerArchivePage, customerManagerArchiveSave, customerManagerArchiveRemove, getCustomerArchiveReport
    , customerArchiveTransfer
} from '@mdm/api/customer/customerPersonResponsible.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import { ref, reactive, onMounted, onActivated, getCurrentInstance, computed } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
// import lotsSelect from '@/components/lots/lotsSelect/Index';
import reportExport from '@/components/lots/reportExportPlugin';
// import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { handleDictionaryData } from '@/modules/mdm/utils.js';
import _ from 'lodash';
export default {
    name: 'customerPersonResponsible',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        // tableBox,
        editTableBox,
        lotsPagination,
        lotsButton,
        reportExport,
        lotsMdInput
        // lotsSelect
        // columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.customerPersonResponsible);
        const { user } = store.getters;
        const codesToNames = computed(() => {
            function codeToName(codes, optionsKey) {
                const dictObj = dictDatas.value[optionsKey];
                const names = [];
                let codesArr = [];
                if (codes && Array.isArray(codes)) {
                    codesArr = codes;
                } else if (codes) {
                    codesArr = codes.split(',');
                }
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });
        // const tenantCode = store.getters.currentTenant.tenantCode;
        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            edit: -3,
                            allowEdit: true,
                            // disableProps: v.id ? ['respType', 'customerName'] : [],
                            ...v,
                            maintainStatus: v.maintainStatus?.toString(),
                            billSource: v.billSource?.toString(),
                            ruleStatus: v.ruleStatus?.toString(),
                            customerGroupCode: v.customerGroupCode?.split(','),
                            calCustomerLevelCode: v.calCustomerLevelCode?.split(','),
                            ...setOwnerList(v.ownerList)
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const accountList = new AccountListClass({
            Api: {
                listApi: getCustomerManagerArchivePage // 查询接口
            }
        });
        const setOwnerList = data => {
            if (!(Array.isArray(data) && data.length)) return {};
            const ownerNameObj = {};
             // eslint-disable-next-line no-unused-expressions
             data?.forEach((it, index) => {
                 const ownerName = 'ownerName' + (index + 1);
                 const ownerCode = 'ownerCode' + (index + 1);
                 const ownerRatio = 'ownerRatio' + (index + 1);
                 ownerNameObj[ownerName] = it.ownerName;
                 ownerNameObj[ownerCode] = it.ownerCode;
                 ownerNameObj[ownerRatio] = it.ownerRatio;
             });
             return ownerNameObj;
        };
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.effectTime && condition.effectTime.length) {
                condition.effectStartTime = utils.formatDateTime(condition.effectTime[0]);
                condition.effectEndTime = utils.formatDateTime(condition.effectTime[1]);
                Reflect.deleteProperty(condition, 'effectTime');
            }
            if (condition.updateTimes && condition.updateTimes.length) {
                condition.updateEndTime = utils.formatDateTime(condition.updateTimes[1]);
                condition.updateTime = utils.formatDateTime(condition.updateTimes[0]);
                Reflect.deleteProperty(condition, 'updateTimes');
            }
            if (condition.effectEndTimeFixed) {
                condition.effectEndTimeStartTime = utils.formatDate(condition.effectEndTimeFixed[0]);
                condition.effectEndTimeEndTime = utils.formatDate(condition.effectEndTimeFixed[1]);
                Reflect.deleteProperty(condition, 'effectEndTimeFixed');
            }
            if (condition.createTime) {
                condition.startTime = utils.formatDateTime(condition.createTime[0]);
                condition.endTime = utils.formatDateTime(condition.createTime[1]);
                Reflect.deleteProperty(condition, 'createTime');
            }
            if (condition.customerGroupCodes) {
                condition.customerGroupCodeList = condition.customerGroupCodes.split(',');
                Reflect.deleteProperty(condition, 'customerGroupCodes');
                Reflect.deleteProperty(condition, 'customerGroupNames');
            }
            if (condition.regionCodeList) {
                condition.regionNameList = condition.regionCodeList.map(it => {
                    return formatDataDictArray(it, 'APP_COMPANY_AREA');
                });
            }
            if (condition.industryTypeCode) {
                condition.industryTypeList = condition.industryTypeCode.split(',');
                Reflect.deleteProperty(condition, 'industryTypeCode');
                Reflect.deleteProperty(condition, 'industryTypeName');
            }
            const { customerCodes: customerCodeList, companyCodes: companyCodeList, businessCenterCodes: businessCenterCodeList,
                ...rest } = condition;
            const newCondition = { customerCodeList, companyCodeList, businessCenterCodeList, ...rest };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            const keys = ['customerCodeList', 'companyCodeList', 'businessCenterCodeList',
                'ownerCodeList' ];
            keys.forEach(key => {
                if (newCondition[key]) {
                    newCondition[key] = newCondition[key].split(',');
                }
            });
            Reflect.deleteProperty(newCondition, 'businessCenterNames');
            Reflect.deleteProperty(newCondition, 'companyNames');
            Reflect.deleteProperty(newCondition, 'customerNames');
            Reflect.deleteProperty(newCondition, 'ownerNames');
            newCondition.userCode = user.userCode;
            Object.keys(newCondition).forEach(v => {
                !newCondition[v] && newCondition[v] !== 0 && (newCondition[v] = undefined);
            });

            const paramsList = { ...newCondition, ...params };
            Object.keys(paramsList).forEach(v => {
                if (paramsList[v] === undefined || paramsList[v] === null || paramsList[v] === '') {
                    delete paramsList[v];
                }
            });
            return paramsList;
        };
        const config = reactive(configStatic);
        const holePageLoading = ref(false);
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        const addNew = () => { // 新增合同信息
            // setupContext.refs.editTableBox.addRow();
            accountList.totalData.value.unshift({
                edit: 2,
                allowEdit: true,
                respDivide: '6',
                maintainStatus: '1',
                billSource: '1',
                effectEndTime: '2099-01-01'
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        const handleChangeRow = ({ prop, val, type, row, index }) => {
            // if (prop === 'respDivide') {
            //     row.disableProps = row.disableProps || (row.id ? ['respType', 'customerName'] : []);
            //     respDivideAction(row, val);
            // }
            if (['effectStartTime', 'effectEndTime'].includes(prop)) {
                if (row.effectStartTime && row.effectEndTime
                    && new Date(row.effectEndTime).getTime() <= new Date(row.effectStartTime).getTime()) {
                    if (prop === 'effectStartTime') {
                        Message.warning('生效日期必须早于失效日期');
                    } else {
                        Message.warning('失效日期必须晚于生效日期');
                    }
                    row[prop] = null;
                }
            }
        };
        const handleActive = (row, event, index) => {
            if (event === 'edit') {
                // respDivideAction(row, row.respDivide);
            }
        };
        const getDetailedDuplicates = (array) => {
            const results = _.map(array, (item) => {
                const ownerList = item.ownerList || [];
                const codeMap = {};
                const duplicateCodes = new Set();

                _.each(ownerList, (owner) => {
                    const code = owner.ownerCode;
                    if (code in codeMap) {
                        duplicateCodes.add(String(code)); // 确保code转为字符串
                    } else {
                        codeMap[code] = true;
                    }
                });

                return Array.from(duplicateCodes).join(',');
            });

            // 过滤掉空字符串的结果
            return _.filter(results, codeStr => codeStr !== '');
        };

        const saveLoading = ref(false);
        const handleSave = () => {
            if (!accountList.selectedRows.value.length) {
                Message.warning('请勾选要保存的数据');
                return false;
            } else {
                const checkTableData = _.cloneDeep(accountList.selectedRows.value).map(item => {
                    delete item.backup;
                    delete item.edit;
                    delete item.allowEdit;
                    item.ownerList = mergeOwnersToArray(item);
                    return item;
                });
                const allStatusSame = _.every(checkTableData, ['maintainStatus', '1']);
                const ownerListLength = checkTableData.some(it => {
                    const companyCommonPoolRatio = !_.isNil(it.companyCommonPoolRatio) && String(it.companyCommonPoolRatio).trim() !== '';
                    const industryCommonPoolRatio = !_.isNil(it.industryCommonPoolRatio) && String(it.industryCommonPoolRatio).trim() !== '';
                    return it.ownerList.length > 0 || companyCommonPoolRatio || industryCommonPoolRatio;
                });
                if (!allStatusSame || ownerListLength) {
                    if (!setupContext.refs.editTableBox.tableExamine(checkTableData)) { // 编辑表格数据校验
                        return false;
                    }
                    const isRepeatUserCode = getDetailedDuplicates(checkTableData);
                    if (isRepeatUserCode.length) {
                        return Message.warning('当前责任人重复:' + isRepeatUserCode.join(',') + ',请修改');
                    }
                    const validationResult = validateRecords(accountList.selectedRows.value);
                    if (!validationResult.isValid) {
                        let tipsError = '';
                        validationResult.errors.forEach(it => {
                            it.errors.forEach((err, index) => {
                                tipsError = tipsError + err + '<br />';
                            });
                        });
                        Message.warning({
                            message: tipsError,
                            dangerouslyUseHTMLString: true
                        });
                        return;
                    }
                }

                // let timeCheckPass = true;
                // const mastFillStop = checkTableData.some(item => {
                //     if (new Date(item.effectEndTime).getTime() <= new Date(item.effectStartTime).getTime()) {
                //         timeCheckPass = false;
                //     }
                //     return (item.respDivide === '3' && !item.companyCode)
                //         || (item.respDivide === '4' && !item.businessCenterCode)
                //         || (item.respDivide === '5' && !item.siteCode)
                //         || new Date(item.effectEndTime).getTime() <= new Date(item.effectStartTime).getTime();
                // });
                // if (mastFillStop) {
                //     if (!timeCheckPass) {
                //         Message.warning('承接开始时间不能晚于承接结束时间');
                //     } else {
                //         Message.warning('责任划分方式为客户+对应维度时，对应维度不能为空');
                //     }
                //     return false;
                // }

                saveLoading.value = true;
                customerManagerArchiveSave(checkTableData).then(res => {
                    if (+res.code === 0) {
                        Message.success('保存成功');
                        accountList.getList();
                    }
                }).finally(() => {
                    saveLoading.value = false;
                });
            }
        };

        /**
         * 校验记录数组并返回不符合规则的记录
         * @param {Array} records - 要校验的记录数组
         * @param {Object} relatedBillInfo - 关联单据信息 { billNumber: { effectiveDate: Date } }
         * @returns {Array} 包含错误信息的数组，格式为 { name: 记录名称, errors: [错误信息] }
         */
        const eighty = '80';
        const safeToNumber = (value) => {
            // 明确排除空字符串、null、undefined
            if (value === '' || value === null || value === undefined) {
                return undefined;
            }

            // 处理字符串'0'的情况
            if (value === '0') return 0;

            // 使用lodash的toNumber转换
            const num = _.toNumber(value);

            // 确保是有限数字且不是NaN
            return _.isFinite(num) ? num : undefined;
        };
        const isEmptyName = (name) => {
            return _.isNil(name) || _.toString(name).trim() === '';
        };
        const mergeOwnersToArray = (data) => {
            const result = [];

            // 1. 收集所有存在的索引（如1,3,5...）
            const indexes = new Set();
            for (const key in data) {
                if (key.startsWith('ownerName')) {
                    const index = key.replace('ownerName', '');
                    indexes.add(parseInt(index));
                } else if (key.startsWith('ownerRatio')) {
                    const indexRatio = key.replace('ownerRatio', '');
                    indexes.add(parseInt(indexRatio));
                }
            }

            // 2. 对每个存在的索引提取数据
            indexes.forEach(index => {
                const ownerName = data[`ownerName${index}`];
                const ownerCode = data[`ownerCode${index}`];
                const ownerRatio = data[`ownerRatio${index}`];

                // 确保至少有一个字段存在（避免无效索引）
                if (ownerName || ownerCode || ownerRatio) {
                    result.push({
                        ownerName: ownerName, // 不存在则填充null
                        ownerCode: ownerCode,
                        ownerRatio: ownerRatio
                    });
                }
            });
            return result;
        };
        const validateRecords = (dataArray) => {
            // eslint-disable-next-line complexity
            const errors = [];

            // 定义需要校验的字段
            const ownerFields = ['ownerRatio1', 'ownerRatio2', 'ownerRatio3', 'ownerRatio4', 'ownerRatio5'];
            const ownerNameFields = ['ownerName1', 'ownerName2', 'ownerName3', 'ownerName4', 'ownerName5'];
            const commonFields = ['industryCommonPoolRatio', 'companyCommonPoolRatio'];
            const allRatioFields = [...ownerFields, ...commonFields];
            const requiredFields = ['ownerRatio1', 'industryCommonPoolRatio', 'companyCommonPoolRatio'];

            _.forEach(dataArray, (record, index) => {
                const recordErrors = [];
                const recordNumber = index + 1;

                // 转换所有比例为数字，使用安全转换方法
                const ratios = _.mapValues(_.pick(record, allRatioFields), safeToNumber);

                // 规则1: 必填字段至少有一个有效值
                const hasRequiredField = _.some(requiredFields, field =>
                    !_.isUndefined(ratios[field])
                );

                if (!hasRequiredField) {
                    recordErrors.push('主责任人、行业公共池、分公司公共池至少填写一个');
                }

                // 规则2: 责任人比例校验
                _.forEach(ownerFields, (ratioField, i) => {
                    const nameField = ownerNameFields[i];
                    const ratio = ratios[ratioField];
                    const name = record[nameField];
                    // 责任人名称有值时，对应比例必填
                    // 情况1: 有名称必须有比例
                    if (!isEmptyName(name) && _.isUndefined(ratio)) {
                        recordErrors.push(`责任人${i + 1} "${name}" 有名称但未填写比例`);
                    }

                    // 情况2: 有比例必须有名称
                    if (!_.isUndefined(ratio) && isEmptyName(name)) {
                        recordErrors.push(`责任人${i + 1} 填写了比例 ${ratio}% 但未填写名称`);
                    }

                    // 比例不能超过80%
                    if (!_.isUndefined(ratio) && (ratio > +eighty || ratio < 0)) {
                        recordErrors.push(`责任人${i + 1}比例必须在0-80%之间`);
                    }
                });

                // 规则2: 公共池比例校验
                _.forEach(commonFields, field => {
                    const ratio = ratios[field];
                    if (!_.isUndefined(ratio)) {
                        if (ratio < 0) {
                            recordErrors.push(`${field}必须大于等于0`);
                        }
                    }
                });

                // 规则3: 所有比例汇总等于100%
                const sum = _.reduce(allRatioFields, (total, field) => {
                    const val = ratios[field];
                    return total + (_.isNumber(val) ? val : 0);
                }, 0);

                if (sum !== 100) {
                    recordErrors.push(`所有比例之和必须等于100%，当前为${sum}%`);
                }

                if (recordErrors.length > 0) {
                    errors.push({
                        recordName: record.name || `记录${recordNumber}`,
                        errors: recordErrors
                    });
                }
            });

            return {
                isValid: errors.length === 0,
                errors: errors
            };
        };

        const deleteLoading = ref(false);
        const handleDelete = () => {
            if (!accountList.selectedRows.value.length) {
                Message.warning('请勾选要删除的数据');
                return false;
            } else if (accountList.selectedRows.value.every(item => !item.id)) {
                accountList.selectedRows.value.forEach(item => {
                    // eslint-disable-next-line eqeqeq
                    const theIndex = accountList.totalData.value.findIndex(tableItem => tableItem == item);
                    theIndex !== -1 && accountList.totalData.value.splice(theIndex, 1);
                });
                return false;
            } else {
                MessageBox.confirm('是否确认要删除?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const ids = accountList.selectedRows.value.filter(item => !!item.id).map(sub => sub.id);
                    deleteLoading.value = true;
                    customerManagerArchiveRemove({ ids }).then(res => {
                        if (+res.code === 0) {
                            Message.success('删除成功');
                            accountList.getList();
                        }
                    }).finally(() => {
                        deleteLoading.value = false;
                    });
                });
            }
        };
        const handleTransfer = () => {
            const selectedRows = accountList.selectedRows.value;
            if (!selectedRows.length) {
                Message.warning('请勾选要转移的数据');
                return false;
            }
            if (selectedRows.some(it => ['2', '4'].includes(String(it.maintainStatus)))) {
                MessageBox.confirm(`存在“变更中/维护中”的数据，请确认是否继续转移？`, `提示：`, {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    openTransferDialog();
                }).catch(() => { });
            } else {
                openTransferDialog();
            }
        };
        const transferVisible = ref(false);
        const rules = ref({
            billOwnerName: [
                { required: true, message: '单据所有人不能为空', trigger: 'change' }
            ]
        });
        const formData = ref({
            billOwnerName: '',
            billOwnerCode: ''
        });
        const openTransferDialog = () => {
            transferVisible.value = true;
        };
        const getAdvanceValue = (data) => {
            formData.value = data;
        };
        const handleClose = () => {
            transferVisible.value = false;
            setupContext.refs.myFormRef.resetFields();
        };
        const handleConfig = () => {
            setupContext.refs.myFormRef.validate((valid) => {
                if (valid) {
                    const params = {
                        ...formData.value,
                        idList: accountList.selectedRows.value.map(it => it.id)
                    };
                    customerArchiveTransfer(params).then(res => {
                        if (res && +res.code === 0) {
                            Message.success('转移成功');
                            transferVisible.value = false;
                            accountList.getList();
                        }
                    });
                }
            });
        };
        const currentRole = ref({});
        const getCustomerRole = (param) => {
            return getCustomerArchiveReport(param).then(res => {
                if (res && +res.code === 0) {
                    currentRole.value = res.data || {};
                }
            });
        };
        const handleExport = async(submit, type) => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = accountList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const params = {
                ...searchDataFormat(newData),
                deleteFlag: 0
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            const keys = ['customerCodes', 'companyCodes', 'businessCenterCodes', 'siteCodes', 'ownerCodes'];
            keys.forEach(key => {
                if (params[key]) {
                    params[key] = params[key].split(',');
                }
            });
            await getCustomerRole(params);
            const params2 = {
                ...params,
                ...currentRole.value || {}
            };
            submit(params2);
        };
        const rendertable = ref(true);
        const handelView = (row, prop) => {
            row[prop] = true;
            rendertable.value = !rendertable.value;
        };
        const handleLink = (row) => {
            window.open(getMipUrlHandle(row), '_blank');
        };
        const getMipUrlHandle = (row) => {
            if (row.flowCode) {
                const { origin, pathname } = window.location;
                return `${origin}${pathname}#/incomeSharingRules?flowCode=${row.flowCode}`;
            }
            return '';
        };
        const getAuthRole = () => {
            return otherUtils.getHasAuth(
                authorityCode.edit
            );
        };
        const initStatus = ref('1');
        const inputStatus = () => {
            const queryParams = {
                // effectTime: utils.defaultDate('365')
                maintainStatusList: initStatus.value.split(',')
                // effectEndTimeFixed: new Date('2099', '0', '1')
            };
            if (initStatus.value === '1' || initStatus.value === '3') {
                queryParams.effectEndTimeFixed = [new Date('2099', '0', '1'), new Date('2099', '0', '1')];
            }
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        };
        const ctx = getCurrentInstance();
        const handleIncomeSharing = () => {
            ctx.$router.push('/incomeSharingRules');
        };
        const searchChange = ({ column, searchData }) => {
            if (column.value === 'maintainStatusList') {
                initStatus.value = '';
            } else if (column.value === 'industryCategoriesCodeList') {
                config.searchFields.forEach(it => {
                    if (it.value === 'industryTypeName') {
                        it.disabled = !searchData.industryCategoriesCodeList?.length;
                        searchData.industryTypeName = it.disabled ? '' : searchData.industryTypeName;
                        searchData.industryTypeCode = it.disabled ? '' : searchData.industryTypeCode;
                    }
                });
            }
        };
        const editDisableRuleFun = row => {
            // 4 变更中 2维护中
            return [2, 4].includes(+row.maintainStatus);
        };
        const dictDatas = ref({});

        const formatDataDictArray = (val, optionsKey) => {
            if (!_.isNil(val) && val !== '') {
                return dictDatas.value[optionsKey][val];
            }
        };
        const formatData = (row, item) => {
            if (row[item.prop] !== '' && !_.isNil(row[item.prop]) && maintainStatusOptioins.value) {
                return maintainStatusOptioins.value.find(it => it.key === String(row[item.prop]))?.val;
            }
            return '';
        };
        const disabledMaintainStatusList = ['2', '4']; // 禁用 维护中\变更中
        const maintainStatusOptioins = ref([
            { val: '草稿', key: '1' },
            { val: '维护中', key: '2', disabled: true },
            { val: '归档', key: '3' },
            { val: '变更中', key: '4', disabled: true }
        ]);
        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async() => {
            const queryParams = {
                maintainStatusList: initStatus.value.split(','),
                // effectTime: utils.defaultDate('365')
                effectEndTimeFixed: [new Date('2099', '0', '1'), new Date('2099', '0', '1')]

            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
            const dictRes = await getDictDataApi({
                dictCodes: `APP_COMPANY_AREA,MANAGER_ARCHIVE_MAINTAIN_STATUS,SYS_INDUSTRY_TYPE,SYS_CUST_RELATION_TYPE,SYS_WM_CUSTOMER_LEVEL,SYS_SU_MIP_AUDIT_STATUS,MONITOR_STATUS,
                NEOCRM_CUSTOMER_LEVEL`
            });
            dictDatas.value = dictRes.data;
            maintainStatusOptioins.value = handleDictionaryData(dictRes.data.MANAGER_ARCHIVE_MAINTAIN_STATUS)?.map(it => {
                return {
                    val: it.label, key: String(it.value), disabled: disabledMaintainStatusList.includes(String(it.value))
                };
            });
        });
        return {
            accountList,
            config,
            otpColumnConfig,
            showColumnConfigDialog,
            addNew,
            holePageLoading,
            utils,
            authorityCode,
            handleChangeRow,
            saveLoading,
            handleSave,
            deleteLoading,
            handleDelete,
            handleExport,
            handelView,
            rendertable,
            handleActive,
            handleLink,
            getAuthRole,
            getMipUrlHandle,
            initStatus,
            inputStatus,
            handleIncomeSharing,
            searchChange,
            editDisableRuleFun,
            maintainStatusOptioins,
            formatData,
            codesToNames,
            transferVisible,
            handleTransfer,
            formData,
            rules,
            getAdvanceValue,
            handleClose,
            handleConfig
        };
    }
};
</script>
<style lang="less" >
.customer-person {
    width: 100%;
    .customer-person-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .el-tabs {
        width: 100%;
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.customer-person-paper {
        padding: 0px 0px 0px;
    }
    .col-append-box {
        display: flex;
        align-items: center;
        .col-append-btn {
            padding-bottom: 3px;
            padding-left: 3px;
            .eye-btn {
                display: inline-block;
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
    }
    .mip-page-link {
        color: #4285f5;
        cursor: pointer;
        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .mb10{
        margin-bottom: 10px;
    }
}
.customer-person .header-search .search-box .el-select .el-input input{
    height: 28px!important;
}
.bill-tips-color{
    font-size: 12px;
    margin-left: 135px;
    color:#f56c6c
}
</style>
